<template>
    <div class="container-center">


        <div class="forget-form">

            <el-form v-loading="$root.loading" :model="form" status-icon :rules="rules" ref="form" label-width="160px" class="form">
                 <el-form-item label="忘记密码类型：" prop="type">
                    <el-radio-group v-model="form.type" @change="changeType">
                        <el-radio label="1">供应商密码</el-radio>
                        <el-radio label="2">项目经理等其他成员密码</el-radio>
                    </el-radio-group>
                </el-form-item>
                <template v-if="form.type == 2">
                    <el-form-item label="登录名：" prop="loginName">
                        <el-input type="text" :maxlength="11" v-model="form.loginName" auto-complete="off" clearable></el-input>
                    </el-form-item>
                </template>
                 <template v-if="form.type == 1">
                    <el-form-item label="统一社会信用代码：" prop="businessNum">
                        <el-input type="text" v-model="form.businessNum" auto-complete="off" clearable></el-input>
                    </el-form-item>
                </template>
                <el-form-item label="手机号码：" prop="phone">
                    <el-input type="text" :maxlength="11" v-model="form.phone" auto-complete="off" clearable :placeholder="form.type == 1 ? '任意联系人手机号': ''"></el-input>
                </el-form-item>
                
                <el-row type="flex" justify="space-between">
                    <el-col :span="17">
                        <el-form-item label="验证码:" prop="imgCode" class="imgwarp"><i class="icon icon-code"></i>
                            <el-input v-model="form.imgCode" :maxlength="4" ></el-input>
                            <verify-code ref="imgCode"></verify-code>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7" class="send-msg-col">
                        <el-button type="primary" :disabled="codeFlag" size="mini"  class="send-msg-btn"   @click="getCode">{{codeText}}</el-button>
                    </el-col>
                </el-row>
                
                <el-form-item label="短信验证码：" prop="code" class="">
                    <el-col :span="24">
                        <el-input :maxlength="6" v-model="form.code"></el-input>
                    </el-col>
                    <!-- <el-col :span="8" class="text-right">
                        <el-button type="primary" class="getCode" size="mini" @click="getCode" >{{ codeText }}</el-button>
                    </el-col> -->
                </el-form-item>

                <el-form-item label="新密码：" prop="password1">
                    <el-input type="password" v-model="form.password1" auto-complete="off" clearable></el-input>
                </el-form-item>

                <el-form-item label="确认新密码：" prop="password2">
                    <el-input type="password" v-model="form.password2" auto-complete="off" clearable></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" class="submit" size="medium" @click="submit">修改</el-button>
                </el-form-item>

                <div class="error">{{ message }}</div>

            </el-form>

        </div>


    </div><!--container-center-->
</template>

<script>
import util from '@/util'
import VerifyCode from '@/components/VerifyCode'
import banner from '@/assets/imgs/banner_invite.png'

export default {
    name: "forget",
    data() {
        var checkPwd = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入确认新密码'));
            }else{
               if(value != this.form.password1){
                    callback(new Error('两次密码不一致'));
               }else{
                   callback();
               }
            }
        }
        return {
            rules: {
                 type:[
                    { required: true, message: '请选择忘记密码类型', trigger: 'change' }
                ],
                loginName:[
                    { required: true, message: '请输入登录名', trigger: 'blur' }
                ],
                businessNum:[
                    { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
                ],
                phone:[
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { validator: 'regexp', pattern:/^((13|14|15|17|18)[0-9]{1}\d{8})$/, message: '手机号码不正确', trigger: 'blur' }
                ],
                imgCode: [
                    { required: true, message: '请输入4位验证码', trigger: 'blur' },
                    { validator: this.validateCode, message: '验证码不正确', trigger: 'blur'}
                ],
                code:[
                    { required: true, message: '请输入短信验证码', trigger: 'blur' }
                ],
                password1:[
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { min: 6 , message: '请输入正确的密码', trigger: 'blur'}
                ],
                password2:[
                    { required: true, message: '请输入确认新密码', trigger: 'blur' },
                    { min: 6 , message: '请输入正确的密码', trigger: 'blur'},
                    { validator: checkPwd,   trigger: 'blur'}
                ],

            },
            codeFlag: false , // 是否发送短信
            codeText: '获取验证码',
            codeTime: 30,
            codeTimer: {},

            form: {
                type:'2',
                loginName: '',
                businessNum:'', // 企业信用代码
                phone: '',
                imgCode:'', // 图形验证码
                code: '',
                password1: '',
                password2: ''
            },

            message: '',

        }
    },
    computed: {

    },
    components:{verifyCode: VerifyCode},
    methods: {
         validateCode(rule, value, callback){
            if(value.length==4){
                let imgCode = this.$refs.imgCode
                if(value.split('').every((v,i)=>{
                    return new RegExp(v, 'i').test(imgCode.codeChars.charAt(imgCode.codeIndex[i]))
                })){
                    callback()
                } else {
                    callback(new Error(rule.message))
                }
            }else{
                callback(new Error(rule.message))
            }
        },

        getCode() {
            // if(!this.form.loginName) {
            //     this.$message({message:'请输入登录名',type:'error'})
            //     return
            // }
            // // 验证手机号码
            // var reg= /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
            // if(!reg.test(this.form.phone)) {
            //     this.$message({message:'请输入正确的手机号码',type:'error'})
            //     return
            // }

            // // 验证图形验证码
            // let imgCode = this.$refs.imgCode;
            //  if(this.form.imgCode && this.form.imgCode.split('').every((v,i)=>{
            //     return new RegExp(v, 'i').test(imgCode.codeChars.charAt(imgCode.codeIndex[i]))
            // }))

            // // 获取验证码限制
            // if(!this.codeFlag) {
            //     this.$message({message:'请稍后再试',type:'error'})
            //     return
            // }

            let validMsg = [];
            if(this.form.type == 1){
                this.$refs.form.validateField('businessNum',valid=> valid ?  validMsg.push(valid) : null);
            }else{
                this.$refs.form.validateField('loginName',valid=> valid ? validMsg.push(valid) : null);
            }
            this.$refs.form.validateField('phone',valid=> valid ?  validMsg.push(valid) : null);
            this.$refs.form.validateField('imgCode',valid=> valid ?  validMsg.push(valid) : null);
            if(!validMsg.length){
                // 验证是否注册
                let url = this.form.type == 1 ? 'rest/api/dspUserApi/getForgetSupplierSmsCode/' + this.form.phone : 'rest/api/dspUserApi/getForgetSmsCode/' + this.form.phone + '/' + this.form.loginName;
                this.$http.get(url).then((res)=>{
                    if(!res.data.result) {
                        this.$message({message: res.data.message, type:'error'})
                        return
                    }
    
                    this.codeFlag = true
                    this.codeText = this.codeTime +'s后再试'
    
                    this.codeTimer = setInterval(()=>{
                        if(this.codeTime == 1) {
                            this.codeFlag = false
                            this.codeText = '获取验证码'
                            this.codeTime = 30
                            clearInterval(this.codeTimer)
                            return
                        }
                        this.codeTime--
                        this.codeText = this.codeTime +'s后再试'
                    },1000)
    
    
                    // 获取验证码
                    // this.$http.get('rest/api/dspUserApi/getForgetSmsCode/'+ this.form.phone).then((res)=>{
                    //     if(res.data.result) {
                    //         this.$message({message:'验证码已发送',type:'success'})
                    //     } else {
                    //         this.$message({message: res.data.message, type:'error'})
                    //     }
                    // })
                })
            }

        },

        changeType(){
            this.$refs.form.clearValidate();
            // this.$refs.form.resetFields();

        },

        submit() {

            // if(!this.form.loginName) {
            //     this.$message({message:'请输入登录名',type:'error'})
            //     return
            // }

            // // 验证手机号码
            // var reg= /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
            // if(!reg.test(this.form.phone)) {
            //     this.$message({message:'请输入正确的手机号码',type:'error'})
            //     return
            // }

            // if(this.form.code.length!=6) {
            //     this.$message({message:'请输入正确的验证码',type:'error'})
            //     return
            // }

            // if(this.form.password1.length < 6) {
            //     this.$message({message:'请输入正确的密码',type:'error'})
            //     return
            // }

            // if(this.form.password1 != this.form.password2) {
            //     this.$message({message:'两次密码输入不一致',type:'error'})
            //     return
            // }
            this.$refs.form.validate(valid =>{
                if(valid){
                    const loading = this.$loading({background:'rgba(255,255,255,0.5)'});
                    this.$http.post('rest/api/dspUserApi/forgetPwd',{
                        loginName: this.form.loginName,
                        businessNum: this.form.businessNum,
                        phone: this.form.phone,
                        smsCode: this.form.code,
                        newPassword: this.form.password1,
                        type: this.form.type,
                    }).then((res)=>{
                        this.form.password1 = ''
                        this.form.password2 = ''
                        loading.close()
                        if(res.data.result) {
                            this.$message({message:'修改成功',type:'success'})
                            setTimeout(()=>{
                                this.$router.push('/login');
                            },2000)
                        } else {
                            this.$message({message:'修改失败：'+ res.data.message, type:'error'})
                        }
        
                    })
                }
            })

        },

        createRandomCode () {
            this.src = util.baseUrl+'rest/api/dspUserApi/verify/img?'+ +new Date;
        },
    },
    mounted: function() {

    },
    created(){
        this.$root.navs = [{name:'忘记密码',path:'/forget'}];
        this.$root.headImage.src = banner;
        this.createRandomCode();
    }
}

</script>

<style scoped lang="postcss">
@import '../../../assets/common.css';


.forget-form {position: relative;width: 480px;padding: 60px;margin: 0 auto;}
.forget-form button.submit {width: 100%;font-size: 20px;}
.imgwarp {
    position: relative;
}
.imgwarp .validCodeImg,
.imgwarp .verify-code{
    position: absolute;
    top: 6px;
    right:6px;
}
.send-msg-col{
    padding-left:10px;
}
.send-msg-col .send-msg-btn{
    width:100%;
    height:40px;
}

</style>



// WEBPACK FOOTER //
// src/pages/dsp/home/Forget.vue